import React from 'react';
import ModalComponent from 'components/newComponents/Modal';
import { ModalButton } from 'components/newComponents/Buttons';
import CustomerSignForm from './CustomerSignForm';
import TermsOfPaymentForm from './TermsOfPaymentForm';
import AcknowledgeOfTermsForm from './AcknowledgeOfTermsForm';
import InsuranceOptionsForm from './InsuranceOptionsForm';
import Stepper from './Stepper';

function getInitialStep(contract) {
  let initial = 1;

  if (
    contract &&
    !contract.signs.ld_contract_acknowledge_client &&
    !contract.signs.ld_contract_interstate_bill_client &&
    !contract.signs.ld_contract_interstate_bill_client_initials &&
    !contract.signs.ld_contract_terms_of_payment
  ) {
    initial = 1;
  }
  if (
    contract &&
    contract.signs.ld_contract_terms_of_payment &&
    !contract.signs.ld_contract_acknowledge_client &&
    !contract.signs.ld_contract_interstate_bill_client &&
    !contract.signs.ld_contract_interstate_bill_client_initials
  ) {
    initial = 2;
  }
  if (
    contract &&
    contract.signs.ld_contract_terms_of_payment &&
    contract.signs.ld_contract_acknowledge_client &&
    !contract.signs.ld_contract_interstate_bill_client &&
    !contract.signs.ld_contract_interstate_bill_client_initials &&
    contract.insurance_option === 0
  ) {
    initial = 3;
  }
  if (contract && contract.signs.ld_contract_terms_of_payment && contract.signs.ld_contract_acknowledge_client && contract.insurance_option !== 0) {
    initial = 4;
  }

  return initial;
}

export const SignatureDialog = ({ jobId, contract, onClose, refetchContract }) => {
  const [step, setStep] = React.useState(getInitialStep(contract));
  const [pending, setPending] = React.useState(false);

  const next = () => {
    setStep((prev) => {
      if (prev === 4) return 4;
      return prev + 1;
    });
  };

  const title =
    step === 1
      ? 'Terms Of Payment'
      : step === 2
      ? 'Acknowledge of Terms and Conditions'
      : step === 3
      ? "Carrier's Liability Options"
      : step === 4
      ? 'Customer Signature'
      : '';

  const buttonText = step === 1 ? 'Sign next' : step === 2 ? 'Sign next' : step === 3 ? 'Confirm' : step === 4 ? 'Sign' : '';

  return (
    <ModalComponent style={{ maxWidth: 670 }} header={title} show={true} onHide={onClose}>
      <Stepper step={step} />

      {step === 1 && (
        <React.Fragment>
          <div className="ld-contract-invoice-modal-description">
            <p>
              Upon booking a deposit is required to be paid in the form of credit card (Visa, MasterCard, Discover). Prior to pickup 50% of the
              balance is due in the form of credit card, cashier's check, cash or postal money order. 5% admin fee on all credit card transactions.
              Balance must be paid in full upon delivery, prior to off-loading int the form of post office money order or cash only. Carrier reserves
              the right to collect up to 70% balance due prior to the goods leaving the origin state.
            </p>
            <p>Payment in full is required before the delivery truck is opened and before unloading.</p>
          </div>
          <TermsOfPaymentForm jobId={jobId} next={next} refetchContract={refetchContract} setPending={setPending} />
        </React.Fragment>
      )}
      {step === 2 && (
        <React.Fragment>
          <div className="ld-contract-invoice-modal-description">
            <p>SIGN at least 3 days before pickup date:</p>
            <p>
              I acknowledge I have read and agree to all the terms and conditions on both sides of this bill of lading contract. I have received the
              arbitration information and the booklet: Your Rights and Responsibilities When you Move and pamphlet Ready to Move. I agree to pay for
              the total charges for moving services. I approved the total estimated charges prior to the moving services beginning.
            </p>
          </div>
          <AcknowledgeOfTermsForm jobId={jobId} next={next} refetchContract={refetchContract} setPending={setPending} />
        </React.Fragment>
      )}
      {step === 3 && (
        <React.Fragment>
          <InsuranceOptionsForm jobId={jobId} next={next} refetchContract={refetchContract} setPending={setPending} />
        </React.Fragment>
      )}
      {step === 4 && (
        <React.Fragment>
          <CustomerSignForm
            jobId={jobId}
            insuranceOption={contract.insurance_option}
            refetchContract={refetchContract}
            close={onClose}
            setPending={setPending}
          />
        </React.Fragment>
      )}

      <div className="footer-buttons">
        <ModalButton title="Cancel" variant="cancel" onClick={onClose} />
        <button
          type="submit"
          className="confirm"
          disabled={pending}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          form="ld-contract-invoice-modal"
        >
          {pending ? <span className="inline-preloader inline-preloader--small" style={{ position: 'relative' }} /> : <span>{buttonText}</span>}
        </button>
      </div>
    </ModalComponent>
  );
};
